module.exports = __webpack_public_path__ + "static/media/docx.d313b934.png";